// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"d25bf0fd","272":"a6988b9a","347":"c9eedf9b","864":"072eb57c","884":"4f4857dd","897":"f2f37982","901":"aefcf001","966":"54af4bff","993":"34ab17ba"}[chunkId] + ".chunk.js";
};